/** KlasseWerk: a single, small enhancement for the Dawn header. */
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  const updateHeader = () => header.classList.toggle('kw-header--scrolled', window.scrollY > 24);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
});
